import React from "react";

type BadgeSize = "sm" | "md";

interface ScoreBadgeProps {
  score: number | null;
  size?: BadgeSize;
}

interface BadgeStyle {
  background: string;
  color: string;
  boxShadow: string;
}

function scoreBadgeStyle(score: number | null): BadgeStyle {
  if (score === null || score === undefined) {
    return {
      background: "#1a1a1a",
      color: "#444444",
      boxShadow: "none",
    };
  }
  if (score >= 7) {
    return {
      background: "#4ade80",
      color: "#050505",
      boxShadow: "0 0 12px rgba(74, 222, 128, 0.4)",
    };
  }
  if (score >= 4) {
    return {
      background: "#facc15",
      color: "#050505",
      boxShadow: "0 0 12px rgba(250, 204, 21, 0.4)",
    };
  }
  return {
    background: "rgba(255,255,255,0.08)",
    color: "#a1a1a1",
    boxShadow: "none",
  };
}

function sizeStyle(size: BadgeSize): React.CSSProperties {
  if (size === "md") {
    return {
      width: "3.25rem",
      height: "3.25rem",
      fontSize: "1.125rem",
      borderRadius: "10px",
    };
  }
  return {
    width: "2rem",
    height: "2rem",
    fontSize: "0.75rem",
    borderRadius: "7px",
  };
}

export const ScoreBadge: React.FC<ScoreBadgeProps> = ({ score, size = "sm" }) => {
  const label = score !== null && score !== undefined ? String(score) : "—";
  const ariaLabel =
    score !== null && score !== undefined
      ? `Prioritní skóre: ${score} z 10`
      : "Prioritní skóre není k dispozici";
  const badge = scoreBadgeStyle(score);

  return (
    <span
      style={{
        ...sizeStyle(size),
        ...badge,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "'Syne', sans-serif",
        fontWeight: 700,
        letterSpacing: "-0.02em",
        flexShrink: 0,
        border: "1px solid rgba(255,255,255,0.08)",
      }}
      aria-label={ariaLabel}
      role="img"
    >
      {label}
    </span>
  );
};
